module.exports = {
      id: "live-chat-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#live-chat",
      toString: function () {
        return this.url;
      }
    }